/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, November 2025
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import loadingData from './loading';
import { infoDict, btnStyle, redirectToSummary } from './constants';
import v from './validators';


class ZgodaPrzeznaczenieGruntow extends React.Component {
  state = {
    info: {
      zmiana: null,
      przeznaczenie: null,
      uzasadnienie: null,
    },
    selectedParcels: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
  };

  validators = {
    zmiana: [v.NotSelected],
    przeznaczenie: [v.NotNull],
    uzasadnienie: [v.NotNull],
  };

  onHide = () => this.setState({ showError: false });

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then((r) => {
        if (!r.ok) {
          throw new Error(`Błąd podczas pobierania danych eService: ${r.status}: ${r.statusText}`);
        }
        return r.json();
      })
      .then((resp) => {
        this.setState({ eserviceDistrict: resp, isMounted: true });
      })
      .catch((err) => {
        console.error("Błąd podczas pobierania danych eService:", err);
      });
  }

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const { name, value } = e.target; // <-- wyciągnij od razu!

    this.setState(
      (prevState) => ({
        [group]: {
          ...prevState[group],
          [name]: value,
        },
      }),
      () => this.validate(group, name)
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;

    this.setState(
      (prevState) => ({
        [group]: {
          ...prevState[group],
          [name]: e.value,
        },
      }),
      () => this.validate(group, name)
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const groups = ['info'];
      for (const g of groups) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  hasErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        zmiana: 'option2',
        przeznaczenie: 'przeznaczenie testowe',
        uzasadnienie: 'uzasadnienie testowe'
      },
    })
  };

  postValidation = () => {
    const hasFieldErrors = this.hasErrors();
    if (this.state.selectedParcels.length === 0) {
      return this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
    }

    if (hasFieldErrors) {
      return this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            redirectToSummary(resp.jobId));
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />
        <GrayPanel
          title={'1. Teren'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        <DecisionContainer
          title={'2. Dane wniosku'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={infoDict[this.props.serviceInfo.eservice.shortName] || {}}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ZgodaPrzeznaczenieGruntow.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(ZgodaPrzeznaczenieGruntow),
);



// WEBPACK FOOTER //
// src/routes/eservices/ZgodaPrzeznaczenieGruntow.js